import { OptionModel } from '@/shared/lib/types'

export type StatisticTabNames = 'payIn' | 'payOut'

export const statisticTabsButton: OptionModel[] = [
  { label: 'Входящие', value: 'payIn', index: 0 },
  { label: 'Исходящие', value: 'payOut', index: 1 },
]
